import React from 'react';
import ComparisonTable from '../ComparisonTable';

const PlayerSummaryTab = ({ comparisonData }) => {
  if (!comparisonData) {
    return (
      <div className="md-card">
        <h2>Player Summary</h2>
        <p>Select nation data to load commander summary.</p>
      </div>
    );
  }

  return (
    <div className="md-comparison-section">
      <h2>Player Summary</h2>
      <ComparisonTable
        comparisonData={comparisonData}
        showLocationColumn={false}
        showBloatColumn={false}
      />
    </div>
  );
};

export default PlayerSummaryTab;
